// features/api/communityJourneyApi.js
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const communityJourneyApi = createApi({
  reducerPath: 'communityJourney',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['CommunityJourneys'],
  endpoints: (builder) => ({
    getAllCommunityJourneys: builder.query({
        query: ({ page, limit }) => ({
          url: `journey/community?page=${page +1}&limit=${limit}`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        }),
        transformResponse: (res) => res,
        providesTags: ['CommunityJourneys'],
      }),

      getJourneyDetails: builder.query({
        query: ({ id }) => ({
          url: `journey/${id}`,
          method: 'GET',
        }),
        transformResponse: (res) => res?.data || {},
        providesTags: ['CommunityJourneys'],
      }),

    getJourneyComments: builder.query({ 
      query: ({ id , page ,limit}) => ({
        url: `journey/${id}/comments?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      transformResponse: (res) => res || {},
      providesTags: ['CommunityJourneys'],
    })

  }),
});

export const {
  useGetAllCommunityJourneysQuery,
  useGetJourneyDetailsQuery,
  useGetJourneyCommentsQuery
} = communityJourneyApi;

